import {cn} from "@/lib/utils";

interface CardTitleProps {
    title: React.ReactNode;
    className?: string;
    backgroundImgSrc?: string;
}

export default function CardTitle({ title, className, backgroundImgSrc }: CardTitleProps) {
    return (
        <div className={cn("relative h-[330px] flex justify-center items-center", className)}>
            {backgroundImgSrc && (
                <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${backgroundImgSrc})` }} />
            )}
            <div className="absolute inset-0 bg-black opacity-50" />
            <h2 className="text-white font-bold text-3xl p-4 relative">{title}</h2>
        </div>
    );
}
